export default __webpack_public_path__ + "static/media/cometa.2c44f46c.png";